import React from "react";
import SorensenXgReadBack from "./vendors/sorensen-xg/SorensenXgReadBack";
import SpellmanIcaReadBack from "./vendors/spellman-ica/SpellmanIcaReadBack";
import GammaVacuumSPCeReadBack from "./vendors/gamma-vacuum-spc-e/GammaVacuumSPCeReadBack";
import ScandinovaM1ReadBack from "./vendors/scandinova-m1/ScandinovaM1ReadBack";
import UsePipeReadBackData from "./hooks/UsePipeReadBackData";
import Terranova751AReadBack from "./vendors/terranova-75xa/Terranova751AReadBack";
import Terranova752AReadBack from "./vendors/terranova-75xa/Terranova752AReadBack";
import PfeifferVacuumTpg361ReadBack from "./vendors/pfeiffer-vacuum-tpg-361/PfeifferVacuumTpg361ReadBack";
import PeakComARU2856CReadBack from "./vendors/peak-com-aru2856c/PeakComARU2856CReadBack";
import ScandinovaK1ReadBack from "./vendors/scandinova-k1/ScandinovaK1ReadBack";
import WatlowF4TReadBack from "./vendors/watlow-f4t/WatlowF4TReadBack";

export default function PipeReadBack({hub, pipe}) {
    const data = UsePipeReadBackData({hub, pipe});

    switch (pipe.vendor) {
        case "SORENSEN_XG": {
            return <SorensenXgReadBack pipe={pipe} data={data}/>;
        }

        case "SPELLMAN_ICA": {
            return <SpellmanIcaReadBack pipe={pipe} data={data}/>;
        }

        case "GAMMA_VACUUM_SPC_E": {
            return <GammaVacuumSPCeReadBack pipe={pipe} data={data}/>;
        }

        case "SCANDINOVA_M1": {
            return <ScandinovaM1ReadBack pipe={pipe} data={data}/>;
        }

        case "SCANDINOVA_K1": {
            return <ScandinovaK1ReadBack pipe={pipe} data={data}/>;
        }

        case "TERRANOVA_751A": {
            return <Terranova751AReadBack pipe={pipe} data={data}/>;
        }

        case "TERRANOVA_752A": {
            return <Terranova752AReadBack pipe={pipe} data={data}/>;
        }

        case "PFEIFFER_VACUUM_TPG_261":
        case "PFEIFFER_VACUUM_TPG_361": {
            return <PfeifferVacuumTpg361ReadBack pipe={pipe} data={data}/>;
        }

        case "PEAK_COM_ARU2856C": {
            return <PeakComARU2856CReadBack pipe={pipe} data={data}/>;
        }

        case "WATLOW_F4T": {
            return <WatlowF4TReadBack pipe={pipe} data={data}/>;
        }

        default:
            return null;
    }
}